import { Injectable, Injector, Signal } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { SpinnerOverlayComponent } from 'src/app/shared/components/spinner-overlay/spinner-overlay.component';

@Injectable({ providedIn: 'root' })
export class LoadingOverlayService {
  private overlayRef?: OverlayRef;

  constructor(private overlay: Overlay, private injector: Injector) {}

  private createOverlay(hasBackdrop = true): OverlayRef {
    return this.overlay.create({
      hasBackdrop,
      backdropClass: hasBackdrop ? 'cdk-overlay-dark-backdrop' : undefined,
      positionStrategy: this.overlay.position()
        .global()
        .centerHorizontally()
        .centerVertically(),
    });
  }

  show(diameter = 100, hasBackdrop = true) {
    if (!this.overlayRef) {
      this.overlayRef = this.createOverlay(hasBackdrop);
      const portal = new ComponentPortal(SpinnerOverlayComponent, null, this.injector);
      const compRef = this.overlayRef.attach(portal);
      compRef.setInput('diameter', diameter);
    }
  }

  hide() {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = undefined;
    }
  }
}
